export type EdifyAccessJwtPayload = {
  exp?: number
  iat?: number
  name?: string
  user_name?: string
  device?: string
  ref?: number
  client_id?: string
}

export const decodeEdifyJwtPayload = (
  accessToken: string
): EdifyAccessJwtPayload | null => {
  try {
    const parts = accessToken.split('.')
    if (parts.length < 2) {
      return null
    }
    const segment = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = segment.padEnd(Math.ceil(segment.length / 4) * 4, '=')
    const decoded = JSON.parse(atob(padded))
    return decoded && typeof decoded === 'object' ? decoded : null
  } catch {
    return null
  }
}
